"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var bundle_1 = require("./bundle");
var logger_1 = require("../../logger");
var logger = logger_1.default('Bundle');
var ObjectIterator = /** @class */ (function () {
    function ObjectIterator(object) {
        this.object = object;
        this.index = 0;
        this.values = Object.keys(object).map(function (key) { return object[key]; });
    }
    ObjectIterator.prototype.next = function () {
        if (this.index < this.values.length) {
            return {
                done: false,
                value: this.values[this.index++]
            };
        }
        else {
            return { done: true };
        }
    };
    return ObjectIterator;
}());
exports.ObjectIterator = ObjectIterator;
var BundleManager = /** @class */ (function () {
    function BundleManager(service, variableService) {
        this.service = service;
        this.variableService = variableService;
        this._bundles = {};
    }
    BundleManager.prototype[Symbol
        .iterator] = function () {
        return new ObjectIterator(this._bundles);
    };
    BundleManager.createFromConfig = function (config, service, variableService) {
        var manager = new BundleManager(service, variableService);
        config.forEach(function (bundleConfig) {
            manager.addFromConfig(bundleConfig);
        });
        return manager;
    };
    Object.defineProperty(BundleManager.prototype, "bundles", {
        get: function () {
            return this._bundles;
        },
        enumerable: true,
        configurable: true
    });
    BundleManager.prototype.getConfiguredBundles = function (variables, tap) {
        return __awaiter(this, void 0, void 0, function () {
            var _i, variables_1, variable, variableId, bundleId, bundleConfig, _a, bundle;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _i = 0, variables_1 = variables;
                        _b.label = 1;
                    case 1:
                        if (!(_i < variables_1.length)) return [3 /*break*/, 6];
                        variable = variables_1[_i];
                        variableId = variable.config.id;
                        return [4 /*yield*/, tap.service.variable.getBundleId(variableId)];
                    case 2:
                        bundleId = ((_b.sent())).body();
                        if (!!this.getById(bundleId)) return [3 /*break*/, 4];
                        _a = {
                            id: bundleId
                        };
                        return [4 /*yield*/, tap.service.bundle.getName(bundleId)];
                    case 3:
                        bundleConfig = (_a.name = ((_b.sent())).body(),
                            _a.variables = [],
                            _a);
                        this.addFromConfig(bundleConfig);
                        _b.label = 4;
                    case 4:
                        bundle = this.getById(bundleId);
                        bundle.variables.push(variable);
                        _b.label = 5;
                    case 5:
                        _i++;
                        return [3 /*break*/, 1];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    BundleManager.prototype.getById = function (bundleId) {
        return Object.values(this._bundles).find(function (bundle) { return bundle.config.id === bundleId; });
    };
    BundleManager.prototype.get = function (identifier) {
        if (!(identifier in this._bundles)) {
            throw new Error("Bundle with id " + identifier + " does not exist");
        }
        return this._bundles[identifier];
    };
    BundleManager.prototype.add = function (identifier, configOrBundle) {
        if (configOrBundle instanceof bundle_1.Bundle) {
            this._bundles[identifier] = configOrBundle;
        }
        else {
            // logger.debug('Add new bundle config', configOrBundle);
            this._bundles[identifier] = this._createBundle(configOrBundle);
        }
        return this;
    };
    BundleManager.prototype.addFromConfig = function (configs) {
        if (!Array.isArray(configs)) {
            configs = [configs];
        }
        for (var _i = 0, configs_1 = configs; _i < configs_1.length; _i++) {
            var config = configs_1[_i];
            this.add(config.name, config);
        }
        return this;
    };
    BundleManager.prototype.bundle = function (identifier) {
        if (!(identifier in this._bundles)) {
            throw new Error("Bundle \"" + identifier + "\" does not exist");
        }
        return this._bundles[identifier];
    };
    BundleManager.prototype._createBundle = function (config) {
        logger.debug("VariableManager Creating variable " + config.name);
        return bundle_1.Bundle.createFromConfig(config, this.service, this.variableService);
    };
    BundleManager.prototype.clear = function () {
        for (var id in this._bundles) {
            this._bundles[id].monitor().stop();
        }
        this._bundles = {};
    };
    return BundleManager;
}());
exports.BundleManager = BundleManager;
